'use client';

import { useAuth } from '@clerk/nextjs';
import { useEffect, useRef } from 'react';
import { clearPwaSessionData } from '@utils/pwa-session-cleanup';

/**
 * Watches Clerk auth and purges SW caches + PWA localStorage when the session
 * ends (covers UserButton, SignOutButton, and any other sign-out path).
 */
export function PwaSignOutCleanup() {
  const { userId, isLoaded } = useAuth();
  const previousUserId = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (!isLoaded) return;

    if (previousUserId.current && !userId) {
      void clearPwaSessionData(previousUserId.current);
    }

    previousUserId.current = userId;
  }, [userId, isLoaded]);

  return null;
}
